"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_MEL_CONFIG = exports.DEFAULT_AUDIO_CONFIG = void 0;
exports.DEFAULT_AUDIO_CONFIG = {
    sampleRate: 16000,
    channelCount: 1,
    bufferSize: 4096
};
exports.DEFAULT_MEL_CONFIG = {
    sampleRate: 16000,
    nFft: 512,
    winLength: 400,
    hopLength: 160,
    nMels: 80,
    preEmphasisCoef: 0.97
};
